import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { StarIcon } from 'lucide-react';
const testimonials = [{
  quote: 'Wir hatten ein CRM, aber es war nicht zufriedenstellend. Auswertungen waren unmöglich, viel manuelle Arbeit. Jetzt haben wir saubere KPIs, einen reibungslosen Workflow und die Automatisierungen sind simpel, klar und funktionieren - das zählt am Ende.',
  author: 'Thorsten Wittmann',
  role: 'Geschäftsführer',
  company: 'TWI International',
  rating: 5
}, {
  quote: 'Die Einfachheit für unser Vertriebsteam ist perfekt. Der Workflow ist komplett gestreamlined und optimiert. Die Schlagzahl hat sich verdoppelt bis verdreifacht - dementsprechend 30 bis 50 Prozent Umsatzsteigerung durch die Zusammenarbeit.',
  author: 'Samin Quraischi',
  role: 'Co-Founder',
  company: 'Hiit The Beat',
  rating: 5
}, {
  quote: 'Ich hab gerade das erste Setting terminiert und es ist einfach geisteskrank, wie es direkt automatisch umschaltet. Die Automatisierung funktioniert perfekt und spart uns extrem viel Zeit im Vertrieb.',
  author: 'Ray Dettmann',
  role: 'Vertriebsleiter',
  company: 'Dreamlife.now',
  rating: 5
}, {
  quote: 'Umsatz von 30k auf 80k gesteigert. Werbebudget auf 15.000€ hochgedreht. Mein Team konzentriert sich nur noch auf Calls - alles andere läuft automatisch. Wir haben locker 200 Wählversuche pro Mitarbeiter. 10 von 10 Zufriedenheit.',
  author: 'Thomas Bux',
  role: 'Geschäftsführer',
  company: 'Bux Consulting',
  rating: 5
}, {
  quote: 'Von Excel-Listen zu kompletter Ordnung. Die Schlagzahl hat sich verdoppelt. Ich konnte alle Aufzeichnungen anhören und sehen, wer wirklich gut ist. Konstantes Wachstum ohne 14-Stunden-Tage. Alles sehr schnell implementiert.',
  author: 'Viktor Bajtinger',
  role: 'Geschäftsführer',
  company: 'Selbstständigkeits-Coaching',
  rating: 5
}, {
  quote: 'Von 28k auf 92k Nettoauftragsvolumen mit 2 Leuten. 300-450 Wählversuche pro Tag statt 100. Ein Mitarbeiter schafft jetzt das, wofür ich früher 2-3 Leute brauchte. Die Produktivität hat sich ver-zwei-drei-vierfacht. Absoluter Gamechanger.',
  author: 'Mario Amadori',
  role: 'Geschäftsführer',
  company: 'E-Commerce Coaching',
  rating: 5
}];
export function Testimonials() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section className="py-24 lg:py-32 bg-[#0a0a0a]" ref={ref} data-id="element-317">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-318">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6
      }} className="text-center max-w-3xl mx-auto mb-16" data-id="element-319">
          <span className="inline-block px-4 py-1.5 rounded-full bg-[#0ea5e9]/10 text-[#0ea5e9] text-sm font-medium mb-6" data-id="element-320">
            Kundenstimmen
          </span>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white leading-tight" data-id="element-321">
            Was unsere Kunden sagen
          </h2>
          <p className="mt-6 text-lg text-gray-400" data-id="element-322">
            Über 50 Unternehmen vertrauen auf unsere Close CRM Expertise. Hier
            sind einige ihrer Erfahrungen.
          </p>
          <p className="text-center text-sm text-gray-600 mb-8" data-id="element-323">
            VERTRAUT VON 110+ UNTERNEHMERN
          </p>
        </motion.div>

        {/* Rating summary */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.5,
        delay: 0.2
      }} className="flex flex-wrap justify-center items-center gap-8 mb-12" data-id="element-324">
          <div className="flex items-center gap-2" data-id="element-325">
            <div className="flex" data-id="element-326">
              {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-6 h-6 text-yellow-400 fill-yellow-400" data-id="element-327" />)}
            </div>
            <span className="text-white font-bold text-xl" data-id="element-328">5.0</span>
          </div>
          <span className="text-gray-500" data-id="element-329">|</span>
          <span className="text-gray-400" data-id="element-330">Basierend auf 110+ Bewertungen</span>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-331">
          {testimonials.map((testimonial, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          duration: 0.5,
          delay: 0.1 + index * 0.1
        }} className="p-6 rounded-2xl bg-[#1a1a1a] border border-white/5" data-id="element-332">
              <div className="flex gap-1 mb-4" data-id="element-333">
                {[...Array(testimonial.rating)].map((_, i) => <StarIcon key={i} className="w-4 h-4 text-yellow-400 fill-yellow-400" data-id="element-334" />)}
              </div>
              <p className="text-gray-300 leading-relaxed mb-6" data-id="element-335">
                "{testimonial.quote}"
              </p>
              <div className="flex items-center gap-3 pt-4 border-t border-white/5" data-id="element-336">
                <div className="w-10 h-10 rounded-full bg-gradient-to-br from-[#0ea5e9] to-[#06b6d4] flex items-center justify-center text-white font-semibold text-sm" data-id="element-337">
                  {testimonial.author.split(' ').map(n => n[0]).join('')}
                </div>
                <div data-id="element-338">
                  <p className="text-white font-medium text-sm" data-id="element-339">
                    {testimonial.author}
                  </p>
                  <p className="text-gray-500 text-xs" data-id="element-340">
                    {testimonial.role}, {testimonial.company}
                  </p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}